document.querySelectorAll('.RoundedCollectionList--inner > a').forEach((link) => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelectorAll('.RoundedCollectionList--inner > a').forEach((el) => {
      el.classList.remove('ActiveCollection--rounded');
    });

    this.classList.add('ActiveCollection--rounded');

    let targetUrl = this.getAttribute('href') + '?sections=main-collection-product-grid';

    fetch(targetUrl)
      .then((response) => response.json()) 
      .then((data) => {
        if (data['main-collection-product-grid']) {
          // Find the correct section dynamically
          const section = document.querySelector('[id^="shopify-section-template"][id$="product-grid"]');
          if (section) {
            section.innerHTML = data['main-collection-product-grid'];
            console.log(data);
          } else {
            console.error('Error: Could not find the section');
          }
        } else {
          console.error('Error: Expected key not found in response', data);
        }
      })
      .catch((error) => console.error('Error loading the page: ', error));
  });
});
